import { createContext, type ReactNode, useContext, useState } from 'react';

export type ToastPosition =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

export interface ToastContextType {
  position: ToastPosition;
  setPosition: (position: ToastPosition) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [position, setPosition] = useState<ToastPosition>('top-right');

  return (
    <ToastContext.Provider value={{ position, setPosition }}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToastPosition() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToastPosition must be used within a ToastProvider');
  }
  return context;
}
